export default __webpack_public_path__ + "images/S4.8c4bfe5.png";